import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';

export const LoadingIcon = (
  <LoadingOutlined
    style={{ fontSize: 24, color: 'rgba(var(--color-primary),1)' }}
    spin
  />
);
